
import Vue from 'vue';
import { Announcement, ANNOUNCEMENT_TYPE } from '@run-diffusion/shared';
import AnnouncementsBanner from '@/components/Toolbar/AnnouncementsBanner.vue';
import JoinOurDiscord from '@/components/JoinOurDiscord/JoinOurDiscord.vue';

export default Vue.extend({
	name: 'AnnouncementPreview',
	data () {
		return {
			ANNOUNCEMENT_TYPE,
		};
	},
	components: {
		JoinOurDiscord,
		AnnouncementsBanner
	},
	props: {
		announcement: {
			type: Object as () => Announcement,
			required: true
		}
	},
	computed: {
		formattedExpiresAt(): string {
			if (!this.announcement.expiresAt) return 'No expiration';
			return new Date(this.announcement.expiresAt.toMillis()).toLocaleString();
		}
	},
});
